// src/utils/tokenStore.js

let token = null;

export const authStore = {
  load() {
    if (typeof window === "undefined") return null;
    const data = JSON.parse(localStorage.getItem("auth"));
    if (data?.authToken) token = data.authToken;
    return data;
  },

  getToken() {
    return token;
  },

  save(data) {
    token = data.authToken;
    localStorage.setItem("auth", JSON.stringify(data));
  },

  clear() {
    token = null;
    localStorage.removeItem("auth");
  },
};
